import React from "react";
import PropTypes from "prop-types";

import FlipOrderRow from "./FlipOrderRow";
import GraphContainer from "./common/GraphContainer";
import LogdevsOverview from "./LogdevsOverview";

const GraphAndSide = (props) => {
  const {
    graphData,
    graphParams,
    graphTitle,
    overview,
    windowEnd,
    windowStart,
  } = props;

  return (
    <FlipOrderRow>
      <div className="graph-and-side-section">
        <GraphContainer
          graphData={graphData}
          graphParams={graphParams}
          graphTitle={graphTitle}
          windowEnd={windowEnd}
          windowStart={windowStart}
        />
      </div>

      <div className="graph-and-side-section">
        <LogdevsOverview overview={overview} />
      </div>
    </FlipOrderRow>
  );
};

GraphAndSide.propTypes = {
  graphData: PropTypes.arrayOf(PropTypes.shape({})),
  graphParams: PropTypes.shape({}),
  graphTitle: PropTypes.string,
  overview: PropTypes.shape({}),
  windowEnd: PropTypes.string,
  windowStart: PropTypes.string,
};

GraphAndSide.defaultProps = {
  graphData: [],
  graphParams: [],
  graphTitle: "",
  overview: {},
  windowEnd: "",
  windowStart: "",
};

export default GraphAndSide;
